import { HttpResponse } from '@angular/common/http';

import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';
import { OrderCoreViewModel } from './types/orderCoreViewModel';
import { OrderViewModel } from './types/orderViewModel';

/**
 * @internal
 */
export class ApiMidbackOrder extends ApiBaseMidBack {
  getClientOrders(params: ParamsAdapter) {
    return this.get<OrderViewModel[]>(`/order/orders-of-clients`, params);
  }

  @ApiOptions({ responseType: 'blob', responseObserve: 'response' })
  exportClientOrders(params: ParamsAdapter) {
    return this.get<HttpResponse<Blob>>(`/order/orders-of-clients/excel`, params);
  }

  @ApiOptions({ channel: 'contractOrderCoreGet' })
  getContractOrdersCoreInfos(contractId: number) {
    return this.get<OrderCoreViewModel[]>(`/order/contract/${contractId}/orders-core`);
  }

  @ApiOptions({ channel: 'contractOrderGet' })
  getContractOrders(contractId: number, priceStripId: number, instrumentId: number) {
    return this.get<OrderViewModel[]>(`/order/contract/${contractId}/price-strip/${priceStripId}/instrument/${instrumentId}/orders`);
  }
}
